import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { CompanyInfo } from '@src/constants';

/**
 * 구글 봇에서 긁어 가는 meta data
 * @param param0
 * @returns
 */
export const GoogleSearchData = ({
  title,
  url,
  description,
  image,
  author,
}: {
  title: string;
  url: string;
  description: string;
  image: string;
  author: string;
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'ComicSeries',
    name: title,
    url,
    publisher: CompanyInfo.NAME_UPPER_CASE,
    inLanguage: 'en',
    description,
    image,
    author: {
      '@type': ':Person',
      name: author,
    },
  };
};

export interface PropsType {
  title: string;
  description: string;
  canonical?: string;
  searchData?: any;
  image?: string;
}

const Seo = ({
  title,
  description,
  canonical = '',
  searchData,
  image,
}: PropsType) => {
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={canonical}
        openGraph={{
          title: title,
          description: description,
          type:'website',
          images: [
            {
              url: image
                ? image
                : `${CompanyInfo.DOMAIN}/images/seo/seo_thumb.jpg`,
              width: image ? 1200 : 470,
              height: image ? 630 : 250,
              alt: title,
            },
          ],
        }}
      />
      <Head>
        {searchData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(searchData),
            }}
          />
        )}

        <meta name="msapplication-tooltip" content={`${title}`} />
        <meta
          name="keywords"
          content="mature webcomics, romantic webtoons, digital comic series, online comics platform, story-driven comics, popular comics app, free webtoon reader, emotional comics, drama stories, high-rated comics"
        />
      </Head>
    </>
  );
};

export default Seo;
